(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fontana-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ffInit === '1') return;
      root.dataset.ffInit = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
      var accBtns = Array.prototype.slice.call(root.querySelectorAll('.ff-tabs__acc-btn'));
      if (!tabs.length) return;

      var mql = window.matchMedia('(max-width: 749px)');

      function selectTab(i) {
        for (var j = 0; j < tabs.length; j++) {
          var on = j === i;
          tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
          tabs[j].setAttribute('tabindex', on ? '0' : '-1');
          if (on) panels[j].classList.add('is-active');
          else panels[j].classList.remove('is-active');
          if (!mql.matches) {
            if (on) panels[j].removeAttribute('hidden');
            else panels[j].setAttribute('hidden', '');
          }
        }
      }

      function togglePanel(i) {
        var open = panels[i].classList.toggle('is-open');
        accBtns[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      for (var i = 0; i < tabs.length; i++) {
        (function (idx) {
          tabs[idx].addEventListener('click', function () {
            selectTab(idx);
            tabs[idx].focus();
          });
          tabs[idx].addEventListener('keydown', function (e) {
            var next = idx;
            switch (e.key) {
              case 'ArrowRight': next = (idx + 1) % tabs.length; break;
              case 'ArrowLeft':  next = (idx - 1 + tabs.length) % tabs.length; break;
              case 'Home':       next = 0; break;
              case 'End':        next = tabs.length - 1; break;
              default: return;
            }
            e.preventDefault();
            selectTab(next);
            tabs[next].focus();
          });
        })(i);
      }

      for (var k = 0; k < accBtns.length; k++) {
        (function (idx) {
          accBtns[idx].addEventListener('click', function () { togglePanel(idx); });
        })(k);
      }

      function applyMode() {
        if (mql.matches) {
          for (var j = 0; j < panels.length; j++) panels[j].removeAttribute('hidden');
        } else {
          for (var j = 0; j < panels.length; j++) {
            if (panels[j].classList.contains('is-active')) panels[j].removeAttribute('hidden');
            else panels[j].setAttribute('hidden', '');
            panels[j].classList.remove('is-open');
            if (accBtns[j]) accBtns[j].setAttribute('aria-expanded', 'false');
          }
        }
      }
      if (mql.addEventListener) mql.addEventListener('change', applyMode);
      else if (mql.addListener) mql.addListener(applyMode);
      applyMode();

      document.addEventListener('shopify:block:select', function (e) {
        if (!root.contains(e.target)) return;
        var idx = panels.indexOf(e.target);
        if (idx < 0) return;
        if (mql.matches) {
          panels[idx].classList.add('is-open');
          if (accBtns[idx]) accBtns[idx].setAttribute('aria-expanded', 'true');
          e.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          selectTab(idx);
        }
      });
    }

    var roots = document.querySelectorAll('[data-ff-tabs]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);

    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-ff-tabs]');
      if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
